import React from 'react';
import '../styles/exam.css';

const InstrumentCompQuestion = ({
  question,
  answers,
  onAnswer,
  onNavigate,
  isFirst,
  isLast,
  onSubmit,
  answeredCount,
  totalQuestions
}) => {
  // Handle both wrapped and unwrapped question formats
  const currentQuestion = question.questions ? question.questions[0] : question;
  const selectedAnswer = answers[currentQuestion.id];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 to-blue-700 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-xl p-8 mb-6">
          {/* Question Header */}
          <div className="mb-6">
            <p className="text-gray-600">
              Study the instruments and select the matching aircraft view
            </p>
          </div>

          {/* Instrument Panel Image */}
          <div className="flex justify-center mb-8 bg-gray-100 rounded-lg p-6">
            <img
              src={currentQuestion.instrumentImage}
              alt="Instrument panel showing attitude and heading indicators"
              className="max-w-full h-auto"
              style={{ maxHeight: '400px' }}
            />
          </div>

          {/* Question Text */}
          <div className="mb-6">
            <p className="text-lg text-gray-800 font-medium">
              {currentQuestion.question}
            </p>
          </div>

          {/* Aircraft View Options (Grid of 4) */}
          <div className="grid grid-cols-2 gap-6 mb-6">
            {currentQuestion.options.map((optionImage, index) => (
              <div
                key={index}
                onClick={() => onAnswer(currentQuestion.id, index)}
                className={`cursor-pointer border-4 rounded-lg p-4 transition-all ${
                  selectedAnswer === index 
                    ? 'border-blue-600 bg-blue-50 shadow-lg' 
                    : 'border-gray-300 hover:border-blue-300 hover:shadow-md'
                }`}
              >
                <div className="flex flex-col items-center">
                  {/* Option Letter */}
                  <div className="w-10 h-10 rounded-full bg-gray-700 text-white flex items-center justify-center font-bold text-lg mb-3">
                    {String.fromCharCode(65 + index)}
                  </div>
                  
                  {/* Aircraft View Image */}
                  <div className="bg-gray-50 rounded p-2 w-full flex justify-center">
                    <img
                      src={optionImage}
                      alt={`Aircraft view option ${String.fromCharCode(65 + index)}`}
                      className="max-w-full h-auto"
                      style={{ maxHeight: '200px' }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-between items-center mt-8 pt-6 border-t">
            <button
              onClick={() => onNavigate('prev')}
              disabled={isFirst}
              className={`px-6 py-3 rounded-lg font-semibold transition ${
                isFirst
                  ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  : 'bg-blue-600 text-white hover:bg-blue-700'
              }`}
            >
              ← Previous
            </button>

            <div className="text-center">
              <p className="text-sm text-gray-600">
                Progress: {answeredCount} / {totalQuestions} answered
              </p>
              <div className="w-48 h-2 bg-gray-200 rounded-full mt-2 overflow-hidden">
                <div
                  className="h-full bg-blue-600 transition-all duration-300"
                  style={{ width: `${(answeredCount / totalQuestions) * 100}%` }}
                />
              </div>
            </div>

            {isLast ? (
              <button
                onClick={onSubmit}
                className="px-6 py-3 rounded-lg font-semibold bg-green-600 text-white hover:bg-green-700 transition"
              >
                Submit Section
              </button>
            ) : (
              <button
                onClick={() => onNavigate('next')}
                className="px-6 py-3 rounded-lg font-semibold bg-blue-600 text-white hover:bg-blue-700 transition"
              >
                Next →
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstrumentCompQuestion;
